import { PropsWithChildren } from 'react';
import classnames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { PolymorphicComponent } from '@hh.ru/magritte-types';

import styles from './icon.less';

interface IconDynamicProps {
    Element?: 'div' | 'span';
    /** На всю ширину */
    stretched?: boolean;
    /** Включает реакцию на hover */
    hoverEnabled?: boolean;
    /** Включает реакцию на press */
    pressEnabled?: boolean;
    className?: string;
}

const IconDynamic: PolymorphicComponent<PropsWithChildren<IconDynamicProps>, 'div'> = ({
    Element = 'div',
    stretched = false,
    hoverEnabled = true,
    pressEnabled = true,
    className,
    ...iconDynamicProps
}) => {
    const forceDisabled = useDisabled();

    return (
        <Element
            className={classnames(styles['icon-dynamic'], {
                [styles.iconDynamicFullWidth]: stretched,
                [styles.iconDynamicDisabled]: forceDisabled,
                [styles.iconDynamicHoverEnabled]: hoverEnabled,
                [styles.iconDynamicPressEnabled]: pressEnabled,
                [className ?? '']: !!className,
            })}
            {...iconDynamicProps}
        />
    );
};

export default IconDynamic;
